import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/auth/useAuth';
import { ROUTES } from '@/lib/routes';

/**
 * Compatibility redirect from the retired root-level `/credentials`
 * page to the new org-scoped Security → Model Providers page (which
 * absorbed the Claude Max / Codex subscription cards alongside the
 * personal `mps_*` keys).
 *
 * `ROUTES.credentials` stays defined so callers that still import
 * the constant keep working; this component lands them on the new
 * URL for the active org. Falls back to `/profile` when no
 * membership is available, mirroring {@link LegacyRedirect}.
 */
export function CredentialsRedirect() {
  const { activeMembership, memberships } = useAuth();
  const slug = activeMembership?.organization.slug ?? memberships[0]?.organization.slug ?? null;
  if (!slug) return <Navigate to={ROUTES.profile} replace />;
  return <Navigate to={ROUTES.org(slug).modelProvidersPersonal} replace />;
}
